import { c as _c } from "react/compiler-runtime";
import { useParams } from "next/navigation";
import { startTransition, useActionState } from "react";
import { meldUnntaksvurderingServerAction } from "@/server/actions/meldUnntaksvurdering";
import type { FetchUpdateResult } from "@/server/tokenXFetch/FetchResult";
interface ActionPayload {
  onSuccess: () => void;
}
export default function useMeldUnntakAction() {
  const $ = _c(7);
  const {
    narmesteLederId
  } = useParams();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      error: null
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [t1, meldUnntakAction, isPending] = useActionState(innerMeldUnntakAction, t0);
  const {
    error
  } = t1;
  async function innerMeldUnntakAction(_previousState, t2) {
    const {
      onSuccess
    } = t2;
    const result = await meldUnntaksvurderingServerAction(narmesteLederId);
    if (result.error === null) {
      onSuccess();
    }
    return result;
  }
  let t3;
  if ($[1] !== meldUnntakAction) {
    t3 = function meldUnntak(onSuccess_0) {
      startTransition(() => {
        meldUnntakAction({
          onSuccess: onSuccess_0
        });
      });
    };
    $[1] = meldUnntakAction;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const meldUnntak = t3;
  let t4;
  if ($[3] !== error || $[4] !== isPending || $[5] !== meldUnntak) {
    t4 = {
      error,
      isPending,
      meldUnntak
    };
    $[3] = error;
    $[4] = isPending;
    $[5] = meldUnntak;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}